import React from "react";
import { OAuthIDP } from "../../../hooks/useOAuth";
import { Button } from "semantic-ui-react";
import classNames from "classnames";

export enum AuthMode {
  Employee = "Employee",
  Public = "Public",
}

export function SSOButton({
  idp,
  initiateOAuth,
  mode,
  isLoading,
  masquerade,
}: {
  idp: OAuthIDP;
  initiateOAuth: (idp: OAuthIDP, masquerade?: string) => void;
  mode: AuthMode;
  isLoading?: boolean;
  masquerade?: string;
}) {
  return (
    <Button
      className={classNames({
        [`tw-mt-2 tw-flex tw-h-11 tw-items-center tw-justify-center tw-rounded-[5px] tw-border-[1px]
        tw-border-solid tw-border-[#00000033] tw-bg-[#FAFBFC] tw-px-4 tw-py-2 tw-text-[14px] tw-font-bold
        tw-text-[#000000E6]`]: true,
        "tw-w-full": mode === AuthMode.Public,
      })}
      type='button'
      primary
      size='large'
      onClick={() => initiateOAuth(idp, masquerade)}
      disabled={isLoading}
    >
      <img
        aria-hidden
        className='tw-mr-2 tw-scale-90'
        src={`/assets/integrations/${idp} Logo.svg`}
        alt={`${idp} Logo`}
      />
      {mode === AuthMode.Public ? idp : `Sign in with ${idp}`}
    </Button>
  );
}
